<template>
  <form class="page-content list-page" @submit.prevent="save">
    <div class="page-content-header with-button">
      <div class="page-title">
        Training Videos
      </div>
    </div>
    <div class="page-content-white">
      <div class="buttons">
        <button class="button button-primary">
          <ion-icon name="checkmark-circle"></ion-icon>
          Save
        </button>
      </div>

      <div class="my-2">
        <training-videos-sections-editor @sections="setSections"></training-videos-sections-editor>
      </div>

      <div class="page-subtitle">
        Videos
      </div>

      <div class="product-videos">
        <div class="loading"
             v-show="loading">
          <div class="fa-3x">
            <i class="fas fa-spinner fa-pulse"></i>
          </div>
        </div>

        <input type="file"
               style="display: none"
               name="newVideo"
               accept="video/*"
               id="newVideo"
               v-on:change="addFile($event)"
        />

        <table class="table table-sm">
          <thead>
            <tr>
              <th>Preview</th>
              <th>Section</th>
              <th>Link</th>
              <th>Embed code</th>
              <th>Title</th>
              <th>Description</th>
              <th>Product model</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(video, index) in videos"
                :key="index">
              <td>
                <video controls
                       crossorigin
                       :src="video.link"
                       style="width: 150px"
                ></video>
              </td>
              <td>
                <select :name="'section-' + video.id"
                        class="form-control"
                        v-model="video.section"
                        required
                        :id="'section-' + video.id">
                  <option v-for="section in sections" :value="section.section">{{section.section}}</option>
                </select>
              </td>
              <td>
                <input type="url"
                       v-model="video.link"
                       :name="'video-' + index"
                       placeholder="Enter video URL"
                       class="form-group grey-input white"
                />
                or
                <label class="button button-primary-outline"
                       for="newVideo"
                       @click="startUpload(index)">
                  <ion-icon name="add-circle"></ion-icon>
                  Upload video
                </label>
              </td>
              <td>
                <textarea :name="'video_embed_code-' + index"
                          :id="'video_embed_code-' + index"
                          v-model="video.embed_code"
                          class="form-group grey-input white"
                          placeholder="Enter HTML embed share code"
                ></textarea>
              </td>
              <td>
                <input type="text"
                       required
                       v-model="video.title"
                       placeholder="Video title"
                       class="form-group grey-input white"
                />
              </td>
              <td>
                <textarea type="text"
                          required
                          v-model="video.description"
                          placeholder="Video title"
                          rows="4"
                          class="form-group grey-input white"
                ></textarea>
              </td>
              <td>
                <input required type="text" class="form-control" v-model="video.product_model" />
              </td>
              <td>
                <div class="actions">
                  <button class="button action remove"
                          type="button"
                          @click="remove(index)">
                    <ion-icon name="remove-circle-outline"></ion-icon>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <th colspan="7">
                <button class="btn btn-success"
                        type="button"
                        @click="add">
                  Add video
                </button>
              </th>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </form>
</template>

<script>
import TrainingVideosSectionsEditor from "./TrainingVideosSectionsEditor";
export default {
  name: "TrainingVideosEditor",
  components: {TrainingVideosSectionsEditor},
  data() {
    return {
      loading: false,
      videos: [],
      sections: [],
      uploadingVideoIndex: ''
    }
  },
  mounted() {
    this.get();
  },
  methods: {
    setSections(sections){
      this.sections = sections
    },
    get(){
      axios.get('/videos/list').then((r) => {
        this.videos = r.data
      })
    },
    save(){
      axios.post('/videos/save', {
        videos: this.videos
      }).then((r) => {
        this.$dlg.toast('Training videos saved!',{
          title: '',
          messageType: 'info',
          closeTime: 2 //auto close dialog time(second)
        });

        this.get()
      })
    },
    startUpload(index) {
      this.uploadingVideoIndex = index
    },
    addFile(event) {
      let file = event.target.files[0];

      if (!file) {
        return
      }

      this.uploadToServer(file)
    },
    uploadToServer(file) {
      let formData = new FormData();
      formData.append('file', file)
      this.loading = true

      axios.post('/videos/upload',
          formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
      ).then((r) => {
        this.videos[this.uploadingVideoIndex].link = r.data.link
        this.uploadingVideoIndex = -1
        $('#newVideo')[0].file = null
        $('#newVideo').val(null)

      }).finally(() => {
        this.loading = false
      })
    },
    add() {
      this.videos.push({
        "link": '',
        "title": '',
        "description": '',
        "product_model": '',
        "section": this.sections[0].section,
      })
    },
    remove(index) {
      let video = this.videos[index]

      if (!video.link) {
        return this.videos.splice(index, 1)
      }

      $.confirm({
        title: '',
        content: `<div style="font-size: 1.3em">Are you sure want to delete this video?</div>`,
        buttons: {
          confirm: {
            text: 'Ok',
            btnClass: 'btn btn-success',
            keys: ['enter'],
            action: () => {
              this.videos.splice(index, 1)
              this.save()
            }
          },
          cancel: {
            text: 'Cancel',
            btnClass: 'btn btn-danger',
            keys: ['esc', 'escape'],
          },
        }
      })
    },
  }
}
</script>

<style scoped>

</style>
